import { Box } from '@mui/material';
import React from 'react';

import Switch from '../../../forms/Switch';

export default function Associated() {
  return (
    <Box sx={{ width: 'fit-content' }}>
      <Switch
        label="Associated with Ad Group"
        name="association.associated"
      />
    </Box>
  );
}
